import React from "react";
import { Box, ThemeProvider, useTheme } from "@mui/material";
import AnimatedHero from "../../components/animated_hero";

export default function ServiceHeroSection() {
  const theme = useTheme();

  const lines = ["Products"];

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ flexGrow: 1 }}>
        <AnimatedHero
          videoSrc="/assets/videos/servicebackground.mp4"
          lines={lines}
        />
      </Box>
    </ThemeProvider>
  );
}
